var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.params.detail.ticket_type == '3')?_c('div',[_c('DetailTripMultdays',{attrs:{"detail":_vm.$route.params.detail}})],1):_c('div',[_c('DetailTrip',{attrs:{"detail":_vm.$route.params.detail}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }